import {
  Box,
  Checkbox,
  Chip,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import DeviceHealthIcons from '../../../Device/components/DeviceHealthIcons/DeviceHealthIcons';
import {
  GetDeviceModelName,
  ListDecoratedMedisanteDevice,
  SelectableDeviceBoxProps,
} from '../../types';
import { useSelectableDeviceBoxStyles } from '../../styles';
import { allGatewayDevices } from '../../../Device/constants';
import { DeviceModels } from '../../../Device/types';

function SelectableDeviceBox(props: SelectableDeviceBoxProps) {
  const {
    device,
    disableSelect,
    onSelectionChanged,
    isSelected,
    onClipboardClick,
    totalView,
  } = props;
  const classes = useSelectableDeviceBoxStyles();
  const history = useHistory();
  const isDeviceGateway = allGatewayDevices.includes(
    device.model as DeviceModels
  );
  const handleClick = (item: ListDecoratedMedisanteDevice) => {
    history.push(`/devices/${encodeURIComponent(item.id)}`);
  };

  const handleClipboardClick = (e: any, txt: string) => {
    e.stopPropagation();
    onClipboardClick(txt);
  };

  const statuses = !device.properties?.status
    ? null
    : device.properties.status.map((status) => {
        return <Chip label={status} key={status} />;
      });

  return (
    <Paper
      className={`${classes.device} ${device.isPinned ? 'pinned' : ''}`}
      onClick={() => handleClick(device)}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={4}>
          <Typography
            variant="h6"
            onClick={(e) => {
              const model = GetDeviceModelName(device);
              handleClipboardClick(e, model);
            }}
          >
            {GetDeviceModelName(device)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ textAlign: 'center' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DeviceHealthIcons
            device={device}
            containerClassName={classes.icons}
            minWidthWithoutEllipsis={140}
          />
        </Grid>

        <Grid container item xs={2} justifyContent="flex-end">
          <Checkbox
            onClick={(e) => e.stopPropagation()}
            checked={isSelected}
            onChange={() => onSelectionChanged(device.id)}
            disabled={disableSelect}
          />
        </Grid>
      </Grid>

      <Box display="flex" flexWrap="wrap" alignContent="flex-end">
        <div className={classes.fvb}>
          <label className={classes.field}>IMEI</label>
          <span
            className={`${classes.value} ${classes.valueLong}`}
            onClick={(e) => {
              handleClipboardClick(e, device.imei);
            }}
          >
            {device.imei}
          </span>
        </div>
        <div className={classes.fvb}>
          <label className={classes.field}>SN</label>
          <span
            className={`${classes.value} ${classes.valueLong}`}
            onClick={(e) => {
              handleClipboardClick(e, device.serialNumber);
            }}
          >
            {device.serialNumber}
          </span>
        </div>
        {device.mac && (
          <div className={classes.fvb}>
            <label className={classes.field}>MAC</label>
            <span
              className={`${classes.value} ${classes.valueLong}`}
              onClick={(e) => {
                handleClipboardClick(e, device.mac || '');
              }}
            >
              {device.mac}
            </span>
          </div>
        )}

        <div className={classes.fvb}>
          <label
            htmlFor={`${device.id}-measurements`}
            id={`label-${device.id}-measurements`}
            className={classes.field}
          >
            Measurements
          </label>
          <span
            id={`${device.id}-measurements`}
            aria-labelledby={`label-${device.id}-measurements`}
            className={`${classes.value} ${classes.valueShort}`}
            onClick={(e) => {
              const toCopy =
                (totalView
                  ? device.measurementCount
                  : device.measurementTripCount) || 0;
              handleClipboardClick(e, `${toCopy}`);
            }}
          >
            {isDeviceGateway
              ? '-'
              : totalView
              ? device.measurementCount
              : device.measurementTripCount}
          </span>
        </div>
        {statuses ? (
          <div className={classes.fvb}>
            <label htmlFor={`${device.id}-statuses`} className={classes.field}>
              Status
            </label>
            <span
              id={`${device.id}-statuses`}
              className={`${classes.value} ${classes.valueLong}`}
            >
              {statuses}
            </span>
          </div>
        ) : null}
      </Box>
    </Paper>
  );
}

export default SelectableDeviceBox;
